import { AuditLog } from './AuditLog';
import { Collaborator } from './Collaborator';
import { Favorite } from './Favorite';
import { ListCollaborator } from './ListCollaborator';
import { MemoCollaborator } from './MemoCollaborator';
import { PipelineCollaborator } from './PipelineCollaborator';
import { Role } from './Role';
import { TaskAssignee } from './TaskAssignee';
import { User } from './User';
import { Workspace } from './Workspace';

export enum MemberPermissionType {
    GUEST = 'Guest', // Read-Only
    MEMBER = 'Member', // Partial Update (Comment, etc.)
    ADMIN = 'Admin', // Create, Delete, Read, Fully Update
    OWNER = 'Owner', // Full-access
    CUSTOM = 'Custom', // Custom Role - depends on assignedRoles
}

export enum MemberStatusType {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    DEACTIVATED = 'Deactivated',
    BLOCKED = 'Blocked',
}

export interface Member {
    id: string;
    user: User;
    workspace: Workspace;
    activeUsers: User[];
    roles: Role[];
    assignedRoles: Role[];
    collaborators: Collaborator[];
    memoCollaborators: MemoCollaborator[];
    pipelineCollaborators: PipelineCollaborator[];
    dashboardCollaborators: PipelineCollaborator[];
    listCollaborators: ListCollaborator[];
    taskAssignees: TaskAssignee[];
    favorites: Favorite;
    permission: MemberPermissionType | undefined;
    status: MemberStatusType | undefined;
    auditLogs: AuditLog[];
    permissionVersion: number;
    createdAt: Date;
    updatedAt: Date;
}
